module.exports = __webpack_public_path__ + "static/media/Shop_VIP_Divider_Glows@3x.c3f72eaf.png";